import React, { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionOverview from './components/SolutionOverview';
import BenefitsGrid from './components/BenefitsGrid';
import WhatsNewSection from './components/WhatsNewSection';
import DashboardPreview from './components/DashboardPreview';
import ArShowcaseSection from './components/ArShowcaseSection';
import PricingSection from './components/PricingSection';
import DemoSection from './components/DemoSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import SiteHeader from '../../components/SiteHeader';

const RestaurantDigitalTransformationLandingPage = () => {
  useEffect(() => {
    // Set page title and meta description
    document.title = 'Cafe Otomasyonu – QR Menü, QR Menü Pro, POS, Online Sipariş, Kurye, Sadakat, Cari ve Yapay Zeka';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 
        'Mekanınızı dijitale taşıyın: QR Menü (sürekli ücretsiz), QR Menü Pro (3D/AR menü ve masadan sipariş), POS, Online Sipariş, Kurye Takip, Sadakat Puanı, Cari & Finans ve Yapay Zeka. Çevrimdışı çalışan POS, mutfak ekranı, reçete-maliyet ve menü mühendisliği tek panelde.'
      );
    }

    /**
     * ⚠️ SAYFA JSON-LD ÜRETMİYOR — `index.html` zaten bir `SoftwareApplication`
     * kaydı basıyor.
     *
     * Burada İKİNCİ bir kayıt daha vardı ve ikisi ÇELİŞİYORDU: biri
     * "4.8 / 127 değerlendirme", diğeri "4.8 / 500" diyordu; fiyat sabit 299₺
     * yazılıydı (katalogdan gelmiyordu) ve `priceValidUntil` 2024-12-31'de
     * dolmuştu. Aynı sayfada iki farklı cevap veren yapısal veri, arama
     * motorunun hangisine inanacağını bilememesi demek.
     *
     * Fiyat vitrini artık `module_catalog`tan besleniyor; yapısal veriyi de
     * oraya bağlamak gerekirse tek yer `index.html` olmalı.
     */

    // Smooth scrolling for anchor links
    const handleAnchorClick = (e) => {
      const href = e.target.getAttribute('href');
      if (href && href.startsWith('#')) {
        e.preventDefault();
        const element = document.getElementById(href.substring(1));
        if (element) {
          const offsetTop = element.offsetTop - 80;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      }
    };

    document.addEventListener('click', handleAnchorClick);

    // Başka sayfadan `/#fiyatlandirma` gibi bir adresle gelindiğinde tarayıcı
    // kaydırmıyor: bölümler bu effect'ten SONRA çiziliyor. Üst menü ve AR
    // sayfası fiyat/iletişim bölümüne böyle bağlanıyor.
    const hashTarget = window.location.hash.slice(1);
    const hashTimer = hashTarget
      ? setTimeout(() => {
          const element = document.getElementById(hashTarget);
          if (element) window.scrollTo({ top: element.offsetTop - 80, behavior: 'smooth' });
        }, 50)
      : null;

    // Cleanup
    //
    // ⚠️ Eskiden burada `script[type="application/ld+json"]` seçilip
    // siliniyordu — İLK eşleşen o script `index.html`in kendi yapısal
    // verisiydi. Yani sayfadan çıkıldığında statik JSON-LD siliniyor,
    // geri dönüldüğünde geri gelmiyordu.
    return () => {
      document.removeEventListener('click', handleAnchorClick);
      if (hashTimer) clearTimeout(hashTimer);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SiteHeader />

      {/* Hero Section */}
      <HeroSection />
      
      {/* Problem Section */}
      <ProblemSection />
      
      {/* Solution Overview */}
      <SolutionOverview />
      
      {/* Benefits Grid */}
      <BenefitsGrid />
      
      {/* Son eklenen özellikler */}
      <WhatsNewSection />
      
      {/* Dashboard Preview */}
      <DashboardPreview />
      
      {/* 3D/AR menü — ayrıntısı /ar-menu */}
      <ArShowcaseSection />
      
      {/* Pricing */}
      <PricingSection />
      
      {/* Demo Section */}
      <DemoSection />
      
      {/* FAQ Section */}
      <FAQSection />

      {/* Contact */}
      <ContactSection />
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default RestaurantDigitalTransformationLandingPage;